<template>
<div>
    <el-form :model="searchForm" ref="searchForm" label-width="80px">
        <el-row>
            <el-col :lg="10" :offset="2" v-show="isShowId">
                <el-form-item label="品牌:">
                    <el-radio-group v-model="searchForm.brand_id" @change="checkInput">
                        <el-radio :label="1">N牌</el-radio>
                        <el-radio :label="2">S牌</el-radio>
                    </el-radio-group>

                </el-form-item>
            </el-col>
            <el-col :lg="10" :offset="2">
                <el-form-item label="美容師:">
                    <el-select v-model="searchForm.userKey">
                        <el-option v-for="item in userList" :key="item._key" :label="item.name" :value="item._key">
                        </el-option>
                    </el-select>

                </el-form-item>

            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="日期間格:">
                    <el-date-picker v-model="searchForm.date" type="daterange" range-separator="到" start-placeholde="開始日期" end-placeholde="結束日期">
                    </el-date-picker>
                </el-form-item>

            </el-col>
            <el-col :lg="10">

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="fetchPerformance">查詢</el-button>

                </el-form-item>
            </el-col>
        </el-row>
        <el-row>

            <el-col :lg="6" :offset="18">
                <el-button type="primary" @click="dialogFormVisible = true">報表</el-button>
                <el-dialog title="報表" :visible.sync="dialogFormVisible" width="40%" center>

                    <el-form :v-model="excelForm" label-width="90px">
                        <el-row justify="center" align="center">
                            <el-col :span="22" :offset="2">
                                <el-form-item label="品牌:">
                                    <el-radio-group v-model.number="excelForm.brand_id" @change="checkInput">
                                        <el-radio :label="1">N牌</el-radio>
                                        <el-radio :label="2">S牌</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="22" :offset="2">
                                <el-form-item label="日期間格:">
                                    <el-date-picker v-model="excelForm.date" type="daterange" range-separator="到" start-placeholde="開始日期" end-placeholde="結束日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="22" :offset="2">
                                <el-form-item label="店櫃:">
                                    <el-select v-model="excelForm.shopKey" filterable>
                                        <el-option v-for="item in shopList" :label="item.name" :value="item._key" :key="item._key"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="22" :offset="2">
                                <el-form-item label="美容師:">
                                    <el-select v-model="excelForm.userKey">
                                        <el-option v-for="item in userList" :key="item._key" :label="item.name" :value="item._key">
                                        </el-option>
                                    </el-select>

                                </el-form-item>
                            </el-col>
                                <el-col :span="22" :offset="2">
                  <el-button type="primary" size="default" @click="checkExcel">確認excel項目</el-button>
                  
                </el-col>
                    <el-col :lg="22" :offset="2" v-if="isCheck">
          <el-form-item label="頁數:">
            <el-select v-model="excelForm.page_limit">
              <el-option
                v-for="item in pages"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
                        </el-row>
                    </el-form>

                    <el-row justify="center" align="center">

                    </el-row>

                    <span slot="footer">
                        <el-button @click="closeExcel">取 消</el-button>
                        <el-button type="primary" @click="downExcel">匯 出</el-button>
                    </span>
                </el-dialog>

            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="">

                </el-form-item>

            </el-col>
            <el-col :lg="10">
                <el-form-item label="業績總計:">
                    {{this.allTotal}}
                </el-form-item>

            </el-col>
        </el-row>
    </el-form>
    <el-row>
        <el-col :lg="22">
            <el-table :data="userPerformanceList.slice((currentPage-1)*pagesize,currentPage*pagesize)" empty-text="暫無數據" :header-cell-style="tableHeaderColor">
                <el-table-column label="日期" prop="day">
                </el-table-column>
                <el-table-column label="名稱" prop="name">
                </el-table-column>
                <el-table-column label="單號" prop="order_id">
                </el-table-column>
                <el-table-column label="主業績" prop="main">
                    <template slot-scope="scope">
                        {{scope.row.main ? '是': '否'}}

                    </template>
                </el-table-column>
                <el-table-column label="個人業績" prop="count">
                    <template slot-scope="scope">
                        {{scope.row.main ? scope.row.count: ""}}

                    </template>
                </el-table-column>
                <el-table-column label="分配業績" prop="count">
                    <template slot-scope="scope">
                        {{scope.row.main ? "": scope.row.count}}

                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next" :total="total1" @current-change="current_change">
            </el-pagination>
        </el-col>
    </el-row>

</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import moment from 'moment'
import toExcel from '@/excel/json2excel'
export default {
    name: 'user',
    data() {
        return {
            searchForm: {
                brand_id: 1,
                date: [],
                userKey: ''
            },
            clearSearchForm: {
                brand_id: 1,
                date: [],
                userKey: ''
            },
            excelForm: {
                "brand_id": 1,
                "date": [],
                "shop_key": '',
                "user_key": '',
                "page_limit": 0,
            },
            clearExcelForm: {
                "brand_id": 1,
                "date": [],
                "shop_key": '',
                "user_key": '',
                "page_limit": 0,
            },
            userPerformanceList: [],
            userList: [],
            salsList: [],
            userExcel: [],
            shopList: [],
            pages: [],
            isCheck: false,
            startDay: '',
            endDay: '',
            total1: 0,
            currentPage: 1,
            pagesize: 10,
            bid: {},
            allTotal: 0,
            users: {},
            isShowId: true,
            dialogVisible: false,
            dialogFormVisible: false,
            brandID: 0,
        }
    },
    computed: mapGetters(["getUserPerformanceList", "getUser", "getUserExcel", "getCheckUserExcel", "getShopList", "getShopDetail"]),
    methods: {
        ...mapGetters(["fetchBuPerformanceList", "fetchUserInfo", "fetchUserPerformanceExcel", "fetchCheckUserPerformanceExcel",  "fetchShopList", "fetchShopDetail"]),

        async fetchPerformance() {
            this.users = JSON.parse(localStorage.getItem('user'))
            this.allTotal = 0
            this.userPerformanceList = []
            if (this.searchForm.date.length != 0) {
                this.startDay = moment(this.searchForm.date[0]).format('YYYY-MM-DD')
                this.endDay = moment(this.searchForm.date[1]).format('YYYY-MM-DD')
            } else {
                this.startDay = ''
                this.endDay = ''
            }
            if (this.users.role == 1) {
                this.brandID = this.users.brand_id
            } else {
                this.brandID = this.searchForm.brand_id
            }
            const data = {
                type: 1,
                user_Key: this.searchForm.userKey,
                brand_id: this.searchForm.brand_id,
                start_day: this.startDay,
                end_day: this.endDay
            }
            await this.$store.dispatch('fetchBuPerformanceList', data)
            this.userPerformanceList = this.getUserPerformanceList
            if (this.userPerformanceList.length == 0) {
                this.userPerformanceList = []
                this.allTotal = 0
                this.total1 = 0
            } else {
                this.total1 = this.userPerformanceList.length
                for (let i = 0; i < this.userPerformanceList.length; i++) {
                    this.allTotal += this.userPerformanceList[i].count
                }

            }
        },

        isShow() {
            this.users = JSON.parse(localStorage.getItem('user'))
            if (this.users.role == 1) {
                this.isShowId = false
            } else {
                this.isShowId = true
            }
        },

        async fetchUserList() {
            if (this.searchForm.brand_id != 0) {
                this.bid = {
                    role: 2,
                    brand_id: this.searchForm.brand_id
                }
            } else {
                this.bid = {
                    role: 2
                }
            }
            await this.$store.dispatch('fetchUser', this.bid)
            this.userList = this.getUser

        },
        async fetchShopList() {
            if (this.excelForm.brand_id != null) {
                this.bid = {
                    brand_id: this.excelForm.brand_id
                };
            } else {
                this.bid = {};
            }
            await this.$store.dispatch("fetchShop", this.bid);
            this.shopList = this.getShopList;
        },

        tableHeaderColor({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (rowIndex === 0) {
                return `background-color: gray;color: #000;`
            }
        },
        current_change: function (currentPage) {
            this.currentPage = currentPage;
        },
        checkInput() {
            this.fetchUserList()
            this.fetchShopList()

        },
        async downExcel() {
            if (this.excelForm.date.length != 0) {
                this.startDay = moment(this.excelForm.date[0]).format('YYYY-MM-DD')
                this.endDay = moment(this.excelForm.date[1]).format('YYYY-MM-DD')
            } else {
                this.startDay = ''
                this.endDay = ''
            }
            const data = {
                brand_id: this.excelForm.brand_id,
                start_date: this.startDay,
                end_date: this.endDay,
                shop_key: this.excelForm.shopKey,
                page_limit: this.excelForm.page_limit,
            }
            await this.$store.dispatch('fetchUserPerformanceExcel', data)
            this.userExcel = this.getUserExcel

            // for (let i = 0; i < this.userExcel.length; i++) {
            //     console.log(this.userExcel[i].order_id.charAt(1))
            //     if (this.userExcel[i].shop_key != 0) {
            //         const data = {_key: this.userExcel[i].shop_key}
            //         await this.$store.dispatch('fetchShopDetail', data)
            //         this.userExcel[i].shop_name = this.getShopDetail.name
            //     }

            // }
            this.DataExcel(this.userExcel, this.startDay, this.endDay)
        },
         async checkExcel() {
            if (this.excelForm.date.length != 0) {
                this.startDay = moment(this.excelForm.date[0]).format('YYYY-MM-DD')
                this.endDay = moment(this.excelForm.date[1]).format('YYYY-MM-DD')
            } else {
                this.startDay = ''
                this.endDay = ''
            }
            const data = {
                brand_id: this.excelForm.brand_id,
                start_date: this.startDay,
                end_date: this.endDay,
                shop_key: this.excelForm.shopKey,
            }
            await this.$store.dispatch('fetchCheckUserPerformanceExcel', data)
            let page = 0
            if (this.getCheckUserExcel % 1000 == 0) {
                page = this.getCheckUserExcel / 1000
            }else {
                page = Math.ceil(this.getCheckUserExcel / 1000)
            }
           for (let i = 0; i < page; i++) {
                this.pages.push({
                "label": i + 1,
                "value": i + 1
            })
               
           }
           console.log(this.getCheckUserExcel)
           this.isCheck = true
         },
        
        

        async DataExcel(datas, statDay, endDay) {
            const th = ['美容師', "訂單日期", "訂單單號", "店櫃名稱", "整單櫃績金額"]
            const filterVal = ['name', 'day', "order_id", "shop_name", "count"]
            const data = datas.map(v => filterVal.map(k => v[k]))
            let tableName = '美容師業績'
            if (statDay != '' && endDay != '') {
                tableName = tableName = tableName + statDay + '-' + endDay
            }
            const [fileName, fileType, sheetName] = [tableName, 'xlsx', tableName]

            const type = 'userPerformance'
            toExcel({
                th,
                data,
                fileName,
                fileType,
                sheetName,
                type,
            })
        },
           closeExcel() {
            this.clearExcel()
            this.dialogFormVisible = false
            this.isCheck = false
        },
        clearExcel() {
            this.excelForm = this.clearExcelForm
            this.pages = []
            
        }
    },
    created() {
        this.fetchUserList(),
            this.fetchShopList(),
            this.isShow()
    },

}
</script>
